export default __webpack_public_path__ + "static/media/VisbyCF-Regular.2835f7af.otf";